import { getStoredProfile } from '../services/authSession';
import { useState, useEffect } from 'react';

export function meetingRoom(value: string): string {
 const input=value.trim();
 if (/^https?:/i.test(input)) {
  try {const url=new URL(input);if(url.protocol!=='https:'||url.hostname!=='meet.jit.si'||url.port||url.username||url.password)return '';return /^[a-zA-Z0-9-]{1,128}$/.test(url.pathname.slice(1))?url.pathname.slice(1):''} catch {return ''}
 }
 return /^[a-zA-Z0-9-]{1,128}$/.test(input)?input:'';
}
function generateRoomId(): string {return 'fpt-'+crypto.randomUUID()}

export default function VideoCallPage() {
  const [roomId, setRoomId] = useState('');
  const [joinRoom, setJoinRoom] = useState('');
  const [activeRoom, setActiveRoom] = useState('');
  const [userName, setUserName] = useState('');
  const [notice,setNotice]=useState('');

  useEffect(() => {
    try {
      const profile = getStoredProfile();
      setUserName(profile.name || profile.hotel_name || 'Participant');
    } catch { /* ignore */ }
  }, []);

  const startCall = () => {
    const room = roomId || generateRoomId();
    setActiveRoom(room);
  };

  const joinExisting = () => {
    const room=meetingRoom(joinRoom);if(room){setNotice('');setActiveRoom(room)}else setNotice('Utilisez un nom de salle ou un lien HTTPS meet.jit.si valide.');
  };

  const endCall = () => setActiveRoom('');

  if (activeRoom) {
    const jitsiUrl = `https://meet.jit.si/${activeRoom}#userInfo.displayName="${encodeURIComponent(userName)}"&config.prejoinPageEnabled=false`;
    return (
      <div style={{ height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '8px 16px', background: 'white', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>Vidéoconférence</strong>
            <span style={{ marginLeft: 12, fontSize: 13, color: '#6b7280' }}>Salle: {activeRoom}</span>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button
              onClick={async() => {try{await navigator.clipboard.writeText(`https://meet.jit.si/${activeRoom}`);setNotice('Lien copié.')}catch{setNotice(`Lien de réunion : https://meet.jit.si/${activeRoom}`)}}}
              className="btn"
              style={{ fontSize: 12 }}
            >
              Copier le lien
            </button>
            <button onClick={endCall} className="btn" style={{ background: '#ef4444', color: 'white', border: 'none', fontSize: 12 }}>
              Terminer
            </button>
          </div>
        </div>
        {notice&&<p role="status">{notice}</p>}
        <iframe title="Session de vidéoconférence"
          src={jitsiUrl}
          style={{ flex: 1, border: 'none', width: '100%' }}
          allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"
        />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div className="card">
        <h3>Vidéoconférence</h3>{notice&&<p role="alert">{notice}</p>}
        <div className="sub">
          Démarrez ou rejoignez une réunion vidéo avec les services ONT, ANR, CNS ou partenaires.
        </div>

        <div style={{ display: 'flex', gap: 24, marginTop: 24, flexWrap: 'wrap' }}>
          {/* Start new call */}
          <div style={{ flex: 1, minWidth: 280, padding: 20, borderRadius: 12, border: '1px solid #e5e7eb', background: '#f0fdf4' }}>
            <h4 style={{ margin: '0 0 8px' }}>Nouvelle réunion</h4>
            <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px' }}>
              Créez une salle et partagez le lien avec vos correspondants.
            </p>
            <input
              type="text"
              placeholder="Nom de la salle (optionnel)"
              maxLength={128}
              value={roomId}
              onChange={e => setRoomId(e.target.value.replace(/[^a-zA-Z0-9-]/g, ''))}
              style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #d1d5db', marginBottom: 12 }}
            />
            <button className="btn primary" style={{ width: '100%' }} onClick={startCall}>
              Démarrer la réunion
            </button>
          </div>

          {/* Join existing */}
          <div style={{ flex: 1, minWidth: 280, padding: 20, borderRadius: 12, border: '1px solid #e5e7eb', background: '#eff6ff' }}>
            <h4 style={{ margin: '0 0 8px' }}>Rejoindre une réunion</h4>
            <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px' }}>
              Entrez le nom ou le lien de la salle pour rejoindre.
            </p>
            <input
              type="text"
              placeholder="Nom de salle ou lien meet.jit.si/..."
              value={joinRoom}
              maxLength={256}
              onChange={e => setJoinRoom(e.target.value)}
              style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #d1d5db', marginBottom: 12 }}
            />
            <button className="btn primary" style={{ width: '100%' }} onClick={joinExisting} disabled={!joinRoom.trim()}>
              Rejoindre
            </button>
          </div>
        </div>
      </div>

      <section className="card"><h3>Réunions avec l’ONT</h3><p>Rejoignez la salle indiquée dans votre invitation ou votre conversation avec le service concerné. Pour organiser une réunion, partagez le lien de votre nouvelle salle avec votre correspondant.</p><a className="btn" href="/messages">Ouvrir la messagerie</a></section>
    </div>
  );
}
